import axios from 'axios';

export const CancelError = axios.Cancel;

export function getRequestReference() {
  window.axios = axios;
  return axios.CancelToken.source();
}
